<template>
    <div class="business-advantage-card">
        <div class="business-advantage-card__top">
            <SvgIcon class="business-advantage-card__icon" 
            :name="iconName"
            size="medium"
            />
            <h4 class="business-advantage-card__title">{{ title }}</h4>
        </div>
        <p class="business-advantage-card__description" v-html="descriptionHtml"></p>
        <p v-if="comment.length" 
            class="business-advantage-card__comment">
            {{ comment }}
        </p>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon';

export default {
    name: 'BusinessAdvantageCard',
    components: {
        SvgIcon
    },
    props: {
        title: {
            type: String,
            required: true
        },
        descriptionHtml: {
            type: String,
            required: true
        },
        comment: {
            type: String,
            required: false,
            default: ''
        },
        iconName: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
}
</script>

<style scoped lang="scss">
.business-advantage-card {
    $border-color: $tetriary;

    height: 100%;

    &__top {
        display: flex;
        align-items: center;
    }

    &__icon {
        color: $primary;
    }

    &__title {
        @include text-average($font-weight-semibold, $line-height-large);

        margin-left: rem($gap-medium);

        color: $primary;

        @media #{$screen-big} {
            font-size: rem($font-size-normal);
        }
    }

    &__description {
        @include text-average($font-weight-medium, $line-height-large);

        margin-top: rem($gap-normal);

        @media #{$screen-big} {
            font-size: rem($font-size-small);
        }
    }

    &__comment {
        @include text-small($font-weight-medium, $line-height-large);
        margin-top: rem($gap-mini);

        color: $primary-weekened;

        @media #{$screen-big} {
            font-size: rem($font-size-mini);
        }
    }
}
</style>